import React from 'react'
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';


function AppointmentCard({ appointment, white }) {
    
    dayjs.extend(advancedFormat);

    return(
        <div key={appointment.uri} className={`flex justify-between ${white ? 'bg-white' : 'bg-gray-100'} py-4 px-8 rounded-lg`}>
            <div>
                <p className="text-secondary font-semibold">{appointment.partnerName}</p>
                <p className="text-gray-500">{appointment.partnerType}</p>
            </div>
            <div>
                <p className="text-secondary font-semibold">{dayjs(appointment.startTime).format('MMM Do')}</p>
                <p className="text-gray-500">@ {dayjs(appointment.startTime).format('h')}:{dayjs(appointment.startTime).format('mm')} {dayjs(appointment.startTime).format('A')}</p>
            </div>
        </div>
    )
}

export default AppointmentCard;